import React from 'react';
import { useSelector } from 'react-redux';
import { ReferenceDot } from 'recharts';

import { getOriginalScenario } from 'advanced/scenarios/scenarioSelectors';
import { getActiveCropNominalWeight } from 'current/currentSelectors';
import { convertScenarioForLocale } from 'advanced/scenarios/util/convertScenarioForLocale';
import COLORS from 'constants/colors';

const RecommendationBaseReferences = () => {
  const originalScenario = useSelector(getOriginalScenario);
  const cropNominalWeight = useSelector(getActiveCropNominalWeight);
  const convertedOriginalScenario = convertScenarioForLocale({ scenario: originalScenario, cropNominalWeight });
  
  return (
    <ReferenceDot
      r={4}
      x={convertedOriginalScenario.avgRate.q}
      y={convertedOriginalScenario.avgEstYield.q}
      fill={COLORS.scenarios.recommendation}
      stroke={COLORS.scenarios.recommendation}
    />
  );
};

export default RecommendationBaseReferences;
